"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ImageCard = _interopRequireDefault(require("../../block/ImageCard"));
var _AirDateFormatter = _interopRequireDefault(require("../../utils/AirDateFormatter"));
var _GetAirdateWrapper = _interopRequireDefault(require("../../utils/GetAirdateWrapper"));
var _Concat = _interopRequireDefault(require("../../utils/Concat"));
var _helpers = require("../../../utils/helpers");
var _ShowSlideModule = _interopRequireDefault(require("./../../../scss/carousels/slide-layouts/ShowSlide.module.scss"));
require("./../../../scss/carousels/slide-layouts/ShowSlide.css");
const determineCtaOptions = (hasSeriesPages, series) => {
  if (hasSeriesPages) {
    // since preventDetailPage is set by the user we want this win out over hasSeriesPages
    if (series.preventDetailPage) return {
      href: '',
      type: 'unknown',
      relatedResourceType: 'unknown'
    };
    if (series.programType === 'film') {
      return {
        href: "movie/".concat(series.slug),
        type: 'internal-link',
        relatedResourceType: 'film'
      };
    } else {
      return {
        href: "show/".concat(series.slug),
        type: 'internal-link',
        relatedResourceType: 'series'
      };
    }
  } else {
    if (series.seriesPrefix) return {
      href: '',
      type: 'show-modal',
      relatedSourceId: series.seriesPrefix,
      relatedResourceType: 'series'
    };
    if (series.titleCode) return {
      href: '',
      type: 'show-modal',
      relatedResourceId: series.titleCode,
      relatedResourceType: 'film'
    };
    return {
      href: '',
      type: 'unknown',
      relatedResourceId: '',
      relatedResourceType: 'unknown'
    };
  }
};
function ShowSlide(_ref) {
  var _series$images$slide$, _series$images, _series$bannerImage, _series$images$slide$2, _series$images2, _series$bannerImage2, _series$bannerMobileI, _series$bannerMobileI2, _series$logoImage, _series$logoImage2, _series$seriesPrefix, _series$logoImage3, _series$logoImage4;
  let {
    series,
    nextAirdate = null,
    titlePosition = 'left',
    titleColor = '#fff',
    fullSizeImagePosition = [50, 50],
    mobileImagePosition = [50, 50],
    lazyLoad = true,
    fetchPriority = null,
    decoding = 'async',
    hasSeriesPages = true,
    handleClicks = () => true,
    altText = ''
  } = _ref;
  const image = {
    url: (_series$images$slide$ = series === null || series === void 0 || (_series$images = series.images) === null || _series$images === void 0 || (_series$images = _series$images.slide) === null || _series$images === void 0 ? void 0 : _series$images.url) !== null && _series$images$slide$ !== void 0 ? _series$images$slide$ : series === null || series === void 0 || (_series$bannerImage = series.bannerImage) === null || _series$bannerImage === void 0 || (_series$bannerImage = _series$bannerImage.image) === null || _series$bannerImage === void 0 ? void 0 : _series$bannerImage.publicUrl,
    altText,
    aspectRatio: 1710 / 850,
    sources: (_series$images$slide$2 = series === null || series === void 0 || (_series$images2 = series.images) === null || _series$images2 === void 0 || (_series$images2 = _series$images2.slide) === null || _series$images2 === void 0 ? void 0 : _series$images2.url) !== null && _series$images$slide$2 !== void 0 ? _series$images$slide$2 : series === null || series === void 0 || (_series$bannerImage2 = series.bannerImage) === null || _series$bannerImage2 === void 0 || (_series$bannerImage2 = _series$bannerImage2.image) === null || _series$bannerImage2 === void 0 ? void 0 : _series$bannerImage2.sources
  };
  const mobileImage = series !== null && series !== void 0 && (_series$bannerMobileI = series.bannerMobileImage) !== null && _series$bannerMobileI !== void 0 && (_series$bannerMobileI = _series$bannerMobileI.image) !== null && _series$bannerMobileI !== void 0 && _series$bannerMobileI.publicUrl ? {
    url: series === null || series === void 0 || (_series$bannerMobileI2 = series.bannerMobileImage) === null || _series$bannerMobileI2 === void 0 || (_series$bannerMobileI2 = _series$bannerMobileI2.image) === null || _series$bannerMobileI2 === void 0 ? void 0 : _series$bannerMobileI2.publicUrl,
    altText,
    aspectRatio: 388 / 594
  } : {
    url: ''
  };
  const showTitleContent = (_series$logoImage = series.logoImage) !== null && _series$logoImage !== void 0 && (_series$logoImage = _series$logoImage.image) !== null && _series$logoImage !== void 0 && _series$logoImage.publicUrl ? "<div class=\"show-slide__logo-wrapper show-slide--display\"><img src=\"".concat((_series$logoImage2 = series.logoImage) === null || _series$logoImage2 === void 0 || (_series$logoImage2 = _series$logoImage2.image) === null || _series$logoImage2 === void 0 || (_series$logoImage2 = _series$logoImage2.sizes) === null || _series$logoImage2 === void 0 || (_series$logoImage2 = _series$logoImage2[0].srcSets) === null || _series$logoImage2 === void 0 ? void 0 : _series$logoImage2[0].src, "\" alt=\"").concat(series.title, "\"/></div><h1 class=\"display-none\">").concat(series.title, "</h1>") : "<h1>".concat(series.title, "</h1>");
  const overlayContent = nextAirdate === null ? /*#__PURE__*/_react.default.createElement(_Concat.default, {
    list: [showTitleContent, /*#__PURE__*/_react.default.createElement(_GetAirdateWrapper.default, {
      programId: (_series$seriesPrefix = series === null || series === void 0 ? void 0 : series.seriesPrefix) !== null && _series$seriesPrefix !== void 0 ? _series$seriesPrefix : series === null || series === void 0 ? void 0 : series.titleCode,
      programType: series !== null && series !== void 0 && series.titleCode ? 'film' : 'series',
      separatorType: "pipe"
    })]
  }) : /*#__PURE__*/_react.default.createElement(_Concat.default, {
    list: [showTitleContent, /*#__PURE__*/_react.default.createElement(_AirDateFormatter.default, {
      airdateStr: nextAirdate,
      separatorType: "pipe"
    })]
  });
  const ctaOptions = determineCtaOptions(hasSeriesPages, series);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_ShowSlideModule.default['show-slide'], 'show-slide']),
    style: {
      '--show-slide-logo-ratio': ((_series$logoImage3 = series.logoImage) === null || _series$logoImage3 === void 0 || (_series$logoImage3 = _series$logoImage3.image) === null || _series$logoImage3 === void 0 ? void 0 : _series$logoImage3.width) / ((_series$logoImage4 = series.logoImage) === null || _series$logoImage4 === void 0 || (_series$logoImage4 = _series$logoImage4.image) === null || _series$logoImage4 === void 0 ? void 0 : _series$logoImage4.height)
    }
  }, /*#__PURE__*/_react.default.createElement(_ImageCard.default, {
    image: image,
    mobileImage: mobileImage,
    fullSizeImagePosition: fullSizeImagePosition,
    mobileImagePosition: mobileImagePosition,
    lazyLoad: lazyLoad,
    fetchPriority: fetchPriority,
    decoding: decoding,
    overlayContent: overlayContent,
    overlayPosition: titlePosition,
    overlayTextColor: titleColor,
    fullCardClickable: series !== null && series !== void 0 && series.preventDetailPage ? false : true,
    cta: ctaOptions,
    handleClicks: hasSeriesPages ? () => true : handleClicks,
    relatedResourceId: hasSeriesPages ? '' : (series === null || series === void 0 ? void 0 : series.programType) === 'film' ? series === null || series === void 0 ? void 0 : series.titleCode : series === null || series === void 0 ? void 0 : series.seriesPrefix
  }));
}
var _default = exports.default = ShowSlide;